import React from 'react'
import {DisplayItemTitle} from '../../styledComponents/DisplayItem'
import {Colors, FontSize, FontWeights} from '../../styledComponents/Constants'
import { Box } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {LeftRowFlexContainer} from '../../styledComponents/FlexComponents'
import {Phone} from '@mui/icons-material'
import {PcMarginLeft30, WhiteArea} from './AccountTransferCommon'
import styled from 'styled-components'
import {currentMedia} from '../../styledComponents/ResponsiveConvenience'
import {Messages} from '../../Messages'

export const ResidentAccountTransferContactUs: React.FC = () =>
    <WhiteArea>
        <DisplayItemTitle>本手続きのお問い合わせ先</DisplayItemTitle>
        <Box height={'10px'}/>
        <PcMarginLeft30>
            <Box fontSize={FontSize.Middle}>長谷工コンタクトセンター</Box>
            <Box height={'8px'}/>
            <LeftRowFlexContainer>
                <BluePhone fontSize={'large'}/>
                <Box width={'12px'}/>
                <Box fontSize={FontSize.Accent} fontWeight={FontWeights.Bold} color={Colors.AccentDark}>
                    {Messages.IRESR0007.toString()}
                </Box>
            </LeftRowFlexContainer>
            <Box height={'4px'}/>
            <AlignItemsStartFlexContainer>
                <Box>受付時間</Box>
                <Box width={'10px'}/>
                <NewLineContents>{Messages.IRESR0014.toString()}</NewLineContents>
            </AlignItemsStartFlexContainer>
        </PcMarginLeft30>
    </WhiteArea>

const BluePhone = withStyles({
    root: {
        color: Colors.Primary,
    }
})(Phone)

const AlignItemsStartFlexContainer = styled(LeftRowFlexContainer)`
  align-items: flex-start;
  font-Size: ${FontSize.Small};
`
const NewLineContents = styled.div`
    ${currentMedia.lessThan('sp')`
      white-space:pre;
  `};
`